export function range(count: number, startAt = 0) {
  return [...Array(count).keys()].map((i) => i + startAt);
}
